import React from 'react'
import { CircularProgress, Theme, makeStyles, createStyles } from "@material-ui/core";
import { CircularProgressProps } from '@material-ui/core/CircularProgress';

interface CircularLoaderProps {
    color?: CircularProgressProps['color']
}

export default function CircularLoader(props: CircularLoaderProps) {
    const classes = useStyles();
    return <div className={classes.root} ><CircularProgress color={props.color} /></div>
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center'
        }
    })
)